import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, TemplateRef, ViewChild,} from '@angular/core';
import {BaseComponent, CompoApiService, CrmIssue, IdAndHeader, Tag} from 'compob2b-libs';
import {takeUntil} from 'rxjs/operators';
import {NgSelectComponent} from '@ng-select/ng-select';

@Component({
    selector: 'app-issue-tag',
    templateUrl: './issue-tag.component.html',
    styleUrls: ['./issue-tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IssueTagComponent extends BaseComponent {
  @Input() issue: CrmIssue;
  @Input() short= false;
  @Input() canEdit = false;
  @Output() changeTag: EventEmitter<Tag> = new EventEmitter();
  @ViewChild('searchElement') searchElement: NgSelectComponent;

  public items: IdAndHeader[] = [];
  public focusInput = false;

  constructor(
    private readonly apiService: CompoApiService) {
    super();
  }

  private loadItems(): void {
    if (!this.items.length) {
      this.apiService
        .get<any[]>('/issue/list-tags')
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(response => {
          this.items = response.data;
          this.items.unshift({id: 0, header: null});
          this.cdr.detectChanges();
        });
    }
  }

  changeSelected(item: Tag): void {
    this.issue.tag = item;
    this.changeTag.emit(item);
    this.focusChange(false);
  }

  showEdit() {
    this.loadItems();
    this.focusChange(true);
    this.searchElement.focus();
    this.searchElement.open();
  }

  focusChange(focusInput: boolean) {
    this.focusInput = focusInput;
    this.cdr.detectChanges();
  }

  showHeader(tag): string {
    return this.short ? tag.header?.substring(0, 1) : tag.header;
  }


}
